import React from "react";
import { Link } from "react-router-dom";
import aiImage from "../../../assets/SMM1.jpg";
import SEOComponent from "../../SEOComponent";
import OptimizedImage from "../../OptimizedImage";
import strategyImage from "../../../assets/SMM-2.jpg";

export default function SocialMediaMarketing() {
  return (
    <div className="bg-gradient-to-br from-black via-gray-900 to-black">
      <SEOComponent 
        title="Social Media Marketing Services - SMM & Social Advertising | AlifShams"
        description="Professional social media marketing services including content strategy, targeted advertising, and social media management across all platforms. Build brand awareness and engagement."
        keywords="social media marketing, SMM, social media advertising, social media management, Facebook marketing, Instagram marketing, LinkedIn marketing, social media strategy"
        url="https://digitalif.net/solutions/digital-marketing/smm"
        type="service"
      />
      {/* Hero Section */}
      <section className="relative h-[60vh] sm:h-[70vh] md:h-[800px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <OptimizedImage
            src={aiImage}
            alt="Social Media Marketing (SMM)"
            className="w-full h-full object-cover sm:object-contain md:object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-80"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 sm:px-6">
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
            Social Media Marketing (SMM)
          </h1>
          <p className="text-sm sm:text-lg md:text-xl lg:text-2xl max-w-3xl mx-auto leading-relaxed">
            Curate engaging social content strategies and run targeted ad
            campaigns across platforms
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
            {/* Image - Left Side */}
            <div className="flex-1 w-full">
              <OptimizedImage
                src={strategyImage}
                alt="Social Media Marketing"
                className="w-full h-64 sm:h-80 md:h-96 object-cover rounded-lg shadow-lg"
              />
            </div>

            {/* Content - Right Side */}
            <div className="flex-1 w-full">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6 text-white text-center lg:text-left">
                Social Media Marketing (SMM)
              </h2>
              <p className="text-sm sm:text-base md:text-lg text-gray-300 leading-relaxed mb-4 sm:mb-6 text-center lg:text-left">
                Curate engaging social content strategies and run targeted ad
                campaigns across platforms.
              </p>
              <p className="text-sm sm:text-base md:text-lg text-gray-300 leading-relaxed text-center lg:text-left">
                We build strong social media presence through strategic content
                creation and targeted advertising that engages your audience and
                drives brand awareness.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Social Media Agency Services Section */}
      <section className="py-16 px-4 sm:px-6 bg-gradient-to-br from-gray-900 via-black to-gray-900">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white">
            Social Media Agency Service Offering
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Social Media Community Management */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Social Media Community Management
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                We manage the running of your social media platforms by designing a content plan with you and handling both the creation and the uploading for you. We ensure that your online presence stays visible and responsive, pushing your brand's social media interaction and engagement. This promotes and strengthens your lead generation capacities and opportunities, allowing you to attract, nurture, and convert leads into clients.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Speak to Us
              </Link>
            </div>

            {/* Social Media Content Creation Services */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Social Media Content Creation Services
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                The content you publish will make or break your social media presence. Knowing what to post, how to design it, and how to optimise it is vital. We develop relevant, engaging content created in line with your industry, its current trends, the objectives of your business, and the concepts that drive engagement.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Speak to Us
              </Link>
            </div>

            {/* Social Media Advertising and Media Services */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Social Media Advertising and Media Services
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                When it comes to product launches, events, or other big announcements and developments in your business, social media platforms are one of your essential channels for advertising to current and potential clients. Our team will run your social media campaigns, managing paid advertising, continuously monitoring and measuring performance, and ensuring that the best approach is utilised throughout the process.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Speak to Us
              </Link>
            </div>

            {/* Social Media Campaigns and Projects */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Social Media Campaigns and Projects
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                If you are looking to run a short-term social media campaign or project and need a professional, experienced agency to create and execute a strategy, we can help.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Speak to Us
              </Link>
            </div>

            {/* Social Media Agency for Events */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Social Media Agency for Events
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                For short-term activations such as conferences, events and exhibitions, social media can help provide (a) initial awareness and ticket sales, (b) drive hype and interest, (c) live engagement with attendees and (d) post-event, scaled down interaction and engagement. ALIF's team of experts will drive event awareness and sales through strategic social media content and marketing.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Speak to Us
              </Link>
            </div>

            {/* Influencer Marketing */}
            <div className="bg-black border border-gray-600 rounded-lg shadow-lg p-6 hover:bg-gray-900 transition-colors duration-300 flex flex-col">
              <h3 className="text-xl font-bold mb-4 text-[#B31F7E]">
                Influencer Marketing
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                ALIF works with global influencers across industries and niches who will boost your brand awareness, ensuring your content is seen and shared. Influencers can create and promote conversation between audiences and your business, encouraging users to engage with you.
              </p>
              <Link 
                to="/contact" 
                className="inline-block bg-[#B31F7E] text-white px-4 py-2 rounded-lg hover:bg-[#9a1a6b] transition-colors duration-300 mt-auto"
              >
                Speak to Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits of Social Media Services Section */}
      <section className="py-16 px-4 sm:px-6 bg-gradient-to-br from-black via-gray-900 to-black">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white">
            Benefits of Social Media Services
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Targeted Goal Setting */}
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#B31F7E]">
                Targeted Goal Setting
              </h3>
            </div>

            {/* Creative Content Creation */}
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#B31F7E]">
                Creative Content Creation
              </h3>
            </div>

            {/* Efficient Platform Management */}
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#B31F7E]">
                Efficient Platform Management
              </h3>
            </div>

            {/* Enhanced Audience Communication */}
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z"/>
                  <path d="M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#B31F7E]">
                Enhanced Audience Communication
              </h3>
            </div>

            {/* Data-Driven Insights */}
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#B31F7E]">
                Data-Driven Insights
              </h3>
            </div>

            {/* Increased Brand Visibility */}
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#482A7A] to-[#B31F7E] rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 12a2 2 0 100-4 2 2 0 000 4z"/>
                  <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#B31F7E]">
                Increased Brand Visibility
              </h3>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
